export enum TypeAlert {
  CONTINUE = "continueChapter",
  INTRO_COURSE = "introCourse",
  INTRO_CHAPTER = "introChapter",
  INTRO_OBJECTIVE = "introObjective",
  QUIZ = "quiz",
  QUIZ_FAILED = "quizFailed",
  END = "endCourse",
  QUIZ_COMPLETE = "quizComplete",
  QUIZ_INIT = "quizInit",
  NO_CERTIFICATE = "noCertificate",

}
